import React from "react";
import Pagination from "../../../../components/Pagination/Pagination";
import styles from "../../Style.module.scss";
import Row from "./Row";
import useCommonStore from "../../../../stores/common";
import useMerchantStore from "../../../../stores/merchant";

function Listing() {
  const showDetails = useCommonStore((state) => state.showDetails);
  const merchantList = useMerchantStore((state) => state.merchantList);
  const setMerchantFilterSearchQuery = useMerchantStore(
    (state) => state.setMerchantFilterSearchQuery,
  );
  const pageCount = useMerchantStore((state) => state.pageCount);
  const currentPage = useMerchantStore((state) => state.currentPage);

  return (
    <>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>DBA</th>
            <th>STATUS</th>
            {!showDetails && <th>VOLUME CAP</th>}
            <th>VOLUME USED</th>
            <th>VOLUME MTD</th>
            {!showDetails && <th>MOM CHANGE</th>}
            {!showDetails && <th>DATE APPROVED</th>}
            <th>ALERT</th>
          </tr>
        </thead>
        <tbody>
          {merchantList.map((app, index) => {
            return <Row key={index} app={app} />;
          })}
        </tbody>
      </table>

      <div className={styles.pagination_container}>
        <Pagination
          pageCount={pageCount}
          currentPage={currentPage - 1}
          onPageChange={({ selected }) => {
            if (selected + 1 !== currentPage) {
              setMerchantFilterSearchQuery({
                page: selected + 1,
              });
            }
          }}
        />
      </div>
    </>
  );
}

export default Listing;
